import React, { PropTypes } from 'react';
import {List} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import PlayerListItem from './PlayerListItem';
import { DropTarget } from 'react-dnd';

const squareTarget = {
  canDrop() {
    return true;
  },

  drop(props, monitor) {
    props.onDropPlayer(monitor.getItem().id, monitor.getItem().listContent);
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  };
}

class PlayerList extends React.Component {
  static propTypes = {
    listContent: PropTypes.object,
    onDropPlayer: PropTypes.func.isRequired,
    players: PropTypes.arrayOf(PropTypes.object)
  };

  render() {
    let { players = [], connectDropTarget, listContent } = this.props;

    return connectDropTarget(
      <div style={{height: '100%'}}>
        <List
          style={{minHeight: 1*72, height: '100%'}}
        >
          {players.map(({ id, name, mediumPhoto, number, role }) => (
            <PlayerListItem
              id={id}
              key={id}
              rightIcon={<div>{number}</div>}
              leftAvatar={<Avatar src={mediumPhoto}/>}
              primaryText={name}
              secondaryText={role}
              listContent={listContent}
            />
          ))}
        </List>
      </div>
    );
  }
}

export default DropTarget('Player', squareTarget, collect)(PlayerList);



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/PlayerListContent/PlayerList.js